import RestAPIClient from "services/RestAPIClient";
import attributeService from "services/attributeService";
import { ContractStatus } from "../constants";
import { IAttribute, IPageableData } from "services/typings";
import {
  IContract,
  IContractRequest,
  IRequestCreation,
  IContractAppendix,
  IContractAppendixDetail,
} from "./typings";

class contractServices extends RestAPIClient {
  constructor() {
    super("contracts");
  }

  getContracts = async (
    req: IContractRequest
  ): Promise<IPageableData<IContract>> => {
    const { filters, ...rest } = req;
    const res = await this.post(`?${this.querystring.stringify(rest as any)}`, {
      filters,
    });
    return {
      data: res.data,
      total: res.pagination.total,
    };
  };

  getUserContract = async (username: string) => {
    const res = await this.get(`/users?username=${username}`);
    return res.data;
  };

  getContractAttributes = async (): Promise<IAttribute[]> => {
    return attributeService.getAttributes({ kind: "contract" });
  };

  getContract = async (id: string): Promise<IContract> => {
    const res = await this.get(`/${id}`);
    return res.data;
  };

  create = async (req: IRequestCreation): Promise<IContract> => {
    const res = await this.post("/create", req);
    return res.data;
  };

  createContractMe = async (req: IRequestCreation): Promise<IContract> => {
    const res = await this.post("/me/create", req);
    return res.data;
  };

  update = async (req: IRequestCreation): Promise<IContract> => {
    const { id, ...rest } = req;
    const res = await this.put(`/${id}`, rest);
    return res.data;
  };

  updateContractMe = async (req: IRequestCreation): Promise<IContract> => {
    const { id, ...rest } = req;
    const res = await this.put(`/me/${id}`, rest);
    return res.data;
  };

  downloadImage = async (id: string): Promise<any> => {
    const res = await this.download(`/kyc/download/${id}`);
    return res;
  };

  downloadImageMe = async (id: string): Promise<any> => {
    const res = await this.download(`/me/kyc/download/${id}`);
    return res;
  };

  updateStatus = async ({
    id,
    status,
  }: {
    id: string;
    status?: ContractStatus;
  }) => {
    if (!status) return Promise.resolve(true);
    const res = await this.put(`/${id}/status`, { status });
    return res.success;
  };

  updateStatusContractme = async ({
    id,
    status,
  }: {
    id: string;
    status?: ContractStatus;
  }) => {
    if (!status) return Promise.resolve(true);
    const res = await this.put(`/me/${id}/status`, { status });
    return res.success;
  };

  getConstants = async () => {
    const res = await this.get("/constant");
    return res.data;
  };

  getConstantsContractMe = async (opts?: { token?: string; kind?: string }) => {
    const { kind = "", ...rest } = opts || {};
    const res = await this.get(`/me/constant?kind=${kind}`, undefined, rest);
    return res.data;
  };

  getContractMe = async (opts?: { token?: string }): Promise<IContract> => {
    const res = await this.get("/me", undefined, opts);
    return res.data;
  };

  downloadContract = async (id: string): Promise<any> => {
    const res = await this.download(`/${id}/download`);
    return res;
  };

  downloadContractMe = async (id: string): Promise<any> => {
    const res = await this.download(`/me/${id}/download`);
    return res;
  };

  getAppendix = async (id: string): Promise<IContractAppendix[]> => {
    const res = await this.get(`/${id}/appendix`);
    return res.data;
  };

  getAppendixDetail = async (id: string): Promise<IContractAppendixDetail> => {
    const res = await this.get(`/appendix/${id}`);
    return res.data;
  };

  downloadAppendix = async (id: string): Promise<any> => {
    const res = await this.download(`/appendix/${id}/download`);
    return res;
  };

  getAppendixMe = async (): Promise<IContractAppendix[]> => {
    const res = await this.get("/appendix/me");
    return res.data;
  };

  getAppendixMeDetail = async (
    id: string
  ): Promise<IContractAppendixDetail> => {
    const res = await this.get(`/appendix/me/${id}`);
    return res.data as IContractAppendixDetail;
  };

  downloadAppendixMe = async (id: string): Promise<any> => {
    const res = await this.download(`/appendix/me/${id}/download`);
    return res;
  };

  updateStatusAppendixMe = async ({
    id,
    status,
  }: {
    id: string;
    status?: ContractStatus;
  }) => {
    if (!status) return Promise.resolve(true);
    const res = await this.put(`/appendix/me/${id}/status`, { status });
    return res.success;
  };
}

export default new contractServices();
